import { render } from "./CarList.vue?vue&type=template&id=2d01dd3c"
import script from "./CarList.vue?vue&type=script&lang=js"
export * from "./CarList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__